import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { SCARequiresNextAction } from 'ha/services/apiV2/types/SCARequiresNextAction';
import { APIV2_URL } from './constants';

interface Payload {
  paymentType: string;
  billingCountry: string;
  signature: string;
  paymentMethodId?: number | null;
  stripeToken?: string;
  stripePaymentMethod?: string | null;
}

export default (makeCall: MakeCall) => (
  conversationId: number,
  data: Payload,
) =>
  makeCall<Conversation | SCARequiresNextAction>(
    'PUT',
    `${APIV2_URL}/conversation/${conversationId}/booking-request`,
    {
      data,
      headers: {
        'X-HA-Features': 'enable-cc-sca',
      },
    },
  );
